import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 카드·레거시 문서 카드 모두 태그·클래스로 스타일링 */
export const SalesContractRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  // 계약 정보 표 바로 아래 시즌 표는 붙여 그림
  '& table + table, & div + div > table': { marginTop: -1 },
  // 카드 사이 간격 — 레거시 문서 카드도 맨 위 div
  '& > div + div': { marginTop: 16 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& .text-left': { textAlign: 'left' },
  '& th.bg-info': { fontWeight: 600 },
  '& .bg-title, & .bg-title > *': {
    textAlign: 'center',
    fontWeight: 600,
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
  },
  '& .vendor-name, & .text-warning': {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
}));
